
























































import GetAuthTokenMutation from '@/graphql/mutations/getAuthToken.gql';
import GetFileCookiesQuery from '@/graphql/queries/getFileCookies.gql';
import request from '@/graphql/request';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class Login extends Vue {
  public username: string = '';
  public password: string = '';
  public errorMessage: string = '';
  private redirectAfter?: string | null;

  get submitClass() {
    return {
      dim: this.username && this.password,
    };
  }

  public mounted() {
    this.redirectAfter = this.$route.query.redirect as string;
  }

  public attemptLogin() {
    this.errorMessage = '';

    const username = this.username;
    const password = this.password;

    request(GetAuthTokenMutation as any, { username, password })
      .then(({ data }) => {
        const token = data && data.getAuthToken;
        if (token) {
          this.$store.dispatch('auth/setAuthToken', token);
          request(GetFileCookiesQuery as any, {}).then((fileData: { data: any }) => {
            if (fileData && fileData.data && fileData.data.getFileCookies) {
              const {
                keyPairId,
                policy,
                signature,
              } = fileData.data.getFileCookies;
              this.$store.dispatch(
                'auth/setFileQueryParams',
                `Key-Pair-Id=${keyPairId}&Policy=${policy}&Signature=${signature}`
              );
            }
            this.$store.dispatch('refreshUser');
            if (this.redirectAfter) {
              this.$router.push(this.redirectAfter);
            } else {
              this.$router.push('/dataStream');
            }
          });
        } else {
          this.errorMessage =
            'Username or password was entered incorrectly. Please try again.';
        }
      })
      .catch(error => {
        this.errorMessage = 'Please try again later.';
      });
  }
}
